import { Err, ResponseData } from 'types';

import { http } from '.';

export const createManager = async (payload) => {
  return await http.post<Err, ResponseData<1>>(`/Managers`, payload);
};

export const updateManager = async (payload) => {
  return await http.put<Err, ResponseData<1>>(`/Managers`, payload);
};

export const getManagers = async () => {
  return await http.get<Err, ResponseData<any>>(`/Managers`);
};

export const deleteManager = async (managerId: number) => {
  return await http.delete<Err, ResponseData<boolean>>(`Managers/${managerId}`);
};
